import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { YaloUtilsService } from '@core/yalo';
import { Subject } from 'rxjs';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { NavigationItem } from '../../common/navigation/navigation.types';
import { IsActiveMatchOptions } from '@angular/router';
import { PermissionsService } from '@core/yalo/user';

@Component({
  selector: 'app-basic-item',
  templateUrl: './basic-item.component.html',
  styleUrls: ['./basic-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BasicItemComponent implements OnInit, OnDestroy {
  @Input() item: NavigationItem;
  @Input() isChild = true;

  isActiveMatchOptions!: IsActiveMatchOptions;
  private readonly _unsubscribeAll = new Subject<void>();

  constructor(
    private _permissions: PermissionsService,
    private _changeDetectorRef: ChangeDetectorRef,
    private _yaloUtilsService: YaloUtilsService
  ) {
    // Set the equivalent of {exact: false} as default for active match options.
    // We are not assigning the item.isActiveMatchOptions directly to the
    // [routerLinkActiveOptions] because if it's "undefined" initially, the router
    // will throw an error and stop working.
    this.isActiveMatchOptions = this._yaloUtilsService.subsetMatchOptions;
  }

  ngOnInit() {
    if (!this.isChild) {
      this._permissions
        .canShowCollapsable(this.item.id)
        .pipe(takeUntil(this._unsubscribeAll), distinctUntilChanged())
        .subscribe((canShow) => {
          if (canShow) {
            this.item.hidden = () => false;
          } else {
            this.item.hidden = () => true;
          }
          this._changeDetectorRef.markForCheck();
        });
    }

    // Set the "isActiveMatchOptions" either from item's
    // "isActiveMatchOptions" or the equivalent form of
    // item's "exactMatch" option
    this.isActiveMatchOptions =
      this.item.isActiveMatchOptions ?? this.item.exactMatch
        ? this._yaloUtilsService.exactMatchOptions
        : this._yaloUtilsService.subsetMatchOptions;
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }
}
